import { ReactComponent as Pause } from "@svgr/webpack?-svgo,+titleProp,+ref!./Pause.svg";
import { ReactComponent as Play } from "@svgr/webpack?-svgo,+titleProp,+ref!./Play.svg";
import { ReactComponent as Stop } from "@svgr/webpack?-svgo,+titleProp,+ref!./Stop.svg";
export const MediaIcons = {
  Pause,
  Play,
  Stop
};
export const MediaIconNames = ["Pause", "Play", "Stop"];